import * as React from 'react';
import { Network } from '@dcl/schemas/dist/dapps/network';
import { BuyManaWithFiatModal as BaseBuyManaWithFiatModal } from 'decentraland-ui/dist/components/BuyManaWithFiatModal/BuyManaWithFiatModal';
import { NetworkGatewayType } from 'decentraland-ui/dist/components/BuyManaWithFiatModal/Network';
import { t } from '../../modules/translation/utils';
import { getAnalytics } from '../../modules/analytics/utils';
export default class BuyManaWithFiatModal extends React.PureComponent {
    analytics = getAnalytics();
    static defaultProps = {
        isLoading: false
    };
    constructor(props) {
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.hasError && this.props.hasError) {
            this.setState({
                hasError: true
            });
        }
        else if (prevProps.hasError && !this.props.hasError) {
            this.setState({
                hasError: false
            });
        }
    }
    getDefaultTranslations(basePath, props) {
        if (!this.props.hasTranslations) {
            return undefined;
        }
        return Object.fromEntries(props.map(it => [it, t(`${basePath}.${it}`)]));
    }
    getDefaultModalTranslations = () => {
        return this.getDefaultTranslations('@dapps.buyManaWithFiat.modal', [
            'title',
            'subtitle',
            'error'
        ]);
    };
    getDefaultNetworkTranslations = (network) => {
        return this.getDefaultTranslations(`@dapps.buyManaWithFiat.network.${network.toLowerCase()}`, ['cta', 'ctaSubtitle', 'title', 'error']);
    };
    getDefaultGatewayTranslations = (network, gateway) => {
        return this.getDefaultTranslations(`@dapps.buyManaWithFiat.network.${network.toLowerCase()}.${gateway}`, ['title', 'subtitle', 'continueButtonText', 'learnMoreText']);
    };
    getDefaultNetworks() {
        const networks = [Network.MATIC, Network.ETHEREUM];
        const gateways = [NetworkGatewayType.MOON_PAY, NetworkGatewayType.TRANSAK];
        const gatewayLearnMoreLink = {
            [NetworkGatewayType.MOON_PAY]: 'https://www.moonpay.com/',
            [NetworkGatewayType.TRANSAK]: 'https://transak.com/'
        };
        const isDisabled = (network, gateway) => network === Network.MATIC && gateway === NetworkGatewayType.MOON_PAY;
        return networks.map(network => ({
            type: network,
            i18n: this.getDefaultNetworkTranslations(network),
            gateways: gateways
                .filter(gateway => !isDisabled(network, gateway))
                .map(gateway => ({
                type: gateway,
                i18n: this.getDefaultGatewayTranslations(network, gateway),
                learnMoreLink: gatewayLearnMoreLink[gateway],
                onContinue: () => this.handleOnContinue(network, gateway)
            })),
            onClick: () => this.handleNetworkOnClick(network)
        }));
    }
    handleOnContinue(network, gateway) {
        this.analytics?.track('Choose Gateway', { network, gateway });
        this.props.onContinue(network, gateway);
        this.props.onClose();
    }
    handleNetworkOnClick(network) {
        this.analytics?.track('Choose Network', { network });
    }
    render() {
        const { i18n, className, isLoading, metadata, onClose, onInfo } = this.props;
        const { hasError } = this.state;
        const networks = this.props.networks || this.getDefaultNetworks();
        return (React.createElement(BaseBuyManaWithFiatModal, { open: true, className: className, i18n: i18n || this.getDefaultModalTranslations(), networks: metadata?.selectedNetwork
                ? networks.filter(network => network.type === metadata.selectedNetwork)
                : networks, loading: isLoading, hasError: hasError, onClose: onClose, onInfo: onInfo }));
    }
}
//# sourceMappingURL=BuyManaWithFiatModal.js.map